import { render, staticRenderFns } from "./EOpcaoUnicaCards.vue?vue&type=template&id=1337401b&scoped=true"
import script from "./EOpcaoUnicaCards.vue?vue&type=script&lang=js"
export * from "./EOpcaoUnicaCards.vue?vue&type=script&lang=js"
import style0 from "./EOpcaoUnicaCards.vue?vue&type=style&index=0&id=1337401b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337401b",
  null
  
)

export default component.exports